// Lib
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Capacitor } from '@capacitor/core';

// Utils
import { getPlatformTypeSelector } from '../../platform/platformSelector';
import { PlatformType } from '../../../common/platform/platformTypes';

// Components
import CustomSelectInput from './CustomSelectInput';

export interface SelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    children: ReactNode;
    title?: string;
    isCancellable?: boolean;
}

const SelectInput = ({ value, onChange, children, className, title, isCancellable = false }: SelectInputProps) => {
    const platform = useSelector(getPlatformTypeSelector);
    const useCustomSelectInput = Capacitor.isNativePlatform() && platform === PlatformType.android;

    // The default 'select' component is being ignored on Android devices running in Capacitor, so
    // we need to use a custom select component in those cases
    if (useCustomSelectInput) {
        return (
            <CustomSelectInput
                className={className}
                value={value}
                onChange={onChange}
                title={title}
                isCancellable={isCancellable}
            >
                {children}
            </CustomSelectInput>
        );
    }

    return (
        <select className={className} value={value} onChange={onChange}>
            {children}
        </select>
    );
};

export default SelectInput;
